// FNP-1192 — the record write path (FNP-1261's `applyDnsRecordChanges`).
//
// ⚠️ ONE MUTATION COVERS CREATE, EDIT AND DELETE, and that is the schema's
// design rather than a shortcut here.
//
// There is no `createDnsRecord`, no `updateDnsRecord` and no `deleteDnsRecord`.
// `applyDnsRecordChanges` takes a BATCH of changes, each carrying its own
// action: UPSERT (create-or-replace) or DELETE. There is no bare CREATE because
// providers disagree about whether creating an existing record is an error, and
// idempotent writes are the only kind this platform wants.
//
// So an "edit" is an UPSERT at the same (name, type), and a rename is not an
// edit at all — it is a DELETE of the old pair plus an UPSERT of the new one.
// See useRecordMutations for where that is assembled.

// ⚠️ `writeState` IS SELECTED AND IS NOT OPTIONAL TO RENDER.
//
// A successful result is NOT a live record. The schema is explicit: PENDING
// means accepted and not yet propagated, SETTLED means live across the
// PROVIDER'S OWN nameservers only, and NOT_REPORTED means the provider cannot
// say either way. A caller that selects `appliedCount` alone and reports "done"
// tells the user their DNS is live when nothing observed that.
//
// `providerChangeReference` is selected so an operator can look the write up at
// the provider. It is OPAQUE and is never parsed — the status deliberately does
// not live inside it.
export const applyDnsRecordChanges = `
    mutation applyDnsRecordChanges($input: ApplyDnsRecordChangesInput!) {
        applyDnsRecordChanges(input: $input) {
            appliedCount
            writeState
            providerChangeReference
        }
    }
`;
